if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const items = [], item = {}, properties = {};
      let quantity = 1, variantId = '';

      for (let i = 0; i < this.form.elements.length; i++) {
        let element = this.form.elements[i];

        if (element.type != 'submit' && element.type != 'button' && element.name != '') {
          if (element.name.match(/^properties\[[\w-_ ]*\]$/)) {
            let name = element.name.match(/\[(.*?)\]/);
            if (name) {
              properties[name[1]] = element.value;
            }
          } else {
            item[element.name] = element.value;
          }
          
          if (element.name == 'quantity') {
            quantity = element.value;
          }

          if (element.name == 'id') {
            variantId = element.value;
          }
        }
      }

      item['properties'] = properties;
      items.push(item);

      const bundleItems = document.querySelectorAll(`.product__bundle-variant[data-variant-id="${variantId}"] .product__bundle-item`);      
      bundleItems.forEach((bundleItem) => {
        items.push({
          'id': bundleItem.getAttribute('data-variant-id'),
          'quantity': quantity,
          'properties': {
            '_bundle_parent_id': variantId
          }
        });
      });

      let body = JSON.stringify({
        'items': items,
        'sections': this.cartNotification.getSectionsToRender().map((section) => section.id),
        'sections_url': window.location.pathname
      });
      
      const config = fetchConfig('javascript');
     
      config.body = body;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
